// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import dogIcon from "@/assets/icons/aop/dog.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type DogIconProps = Omit<IconProps, "name">;

export function DogIcon(props: DogIconProps): React.ReactNode {
  return <Icon name={dogIcon} {...props} />;
}
